import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import useLocalStorage from '../hooks/useLocalStorage';

const DefaultLayout: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [token, _] = useLocalStorage('token', '');
  const [isPass, setIsPass] = useState<boolean>(false);

  useEffect(() => {
    const isInternalSignIn = pathname.endsWith('/internal-signin');

    if (token && !isInternalSignIn) {
      navigate('/sornthai');
    }

    setIsPass(true);
  }, [navigate, pathname, token]);

  return (
    <main>
      <div className="mx-auto max-w-screen-2xl px-8">
        {isPass && <Outlet />}
      </div>
    </main>
  );
};

export default DefaultLayout;
